// src/pages/About.js
import React from 'react';
import About from '../components/About'; // Importing the About component

const AboutPage = () => {
  return (
    <div className="about-page">
      <h1>About Me</h1>
      <About /> 
    </div>
  );
};

export default AboutPage;
